module.exports = __webpack_public_path__ + "img/permission_picture_new5.d867aaf2.png";